import { observer } from 'mobx-react';
import * as React from 'react';
import { equalArrays, includes } from '../../../../../../../../../Collections';
import { default as ProductTypeFilterStore } from '../Store';
import { ProductTypeFilterOptions, labelNames } from '../Types';
import { T } from '../../../../../../../../../Translations';

interface Props {
  option: ProductTypeFilterOptions;
  productTypeFilterStore: ProductTypeFilterStore;
}

const checkboxCondition = (
  option: ProductTypeFilterOptions,
  productTypeFilterStore: ProductTypeFilterStore,
) => {
  switch (option.kind) {
    case 'all-product-types':
      return equalArrays(
        productTypeFilterStore.state.filter.productTypes,
        productTypeFilterStore.initialFilterValues.productTypes,
      );
    case 'some-product-types':
      return includes(option.name, productTypeFilterStore.state.filter.productTypes);
    case 'no-product-types':
      return false;
  }
};

const DropdownItem: React.FC<Props> = ({ option, productTypeFilterStore }) => (
  <button
    onClick={() => productTypeFilterStore.filterAllValues(option)}
    className="flex w-full py-1"
  >
    <div className="flex flex-row bg-white text-gray-700 m-1 justify-between w-full">
      <div className="flex flex-row pr-6">
        <div className="pr-2">
          <div className="flex h-6 items-center">
            <input
              id="offers"
              aria-describedby="offers-description"
              name="offers"
              type="checkbox"
              checked={checkboxCondition(option, productTypeFilterStore)}
              className="h-4 w-4 rounded border-gray-300 text-teal-600 focus:ring-teal-600"
              readOnly
            />
          </div>
        </div>
        <div className="text-sm">
          <T kind={labelNames[option.name]} />
        </div>
      </div>
      <div className="text-sm mr-3">{option.count}</div>
    </div>
  </button>
);

export default observer(DropdownItem);
